import * as React from 'react';
import * as Redux from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import PropTypes from 'prop-types';
import { allEvaluacionesAction } from '../EvaluacionesAction';

const SelectFieldEvaluacionesComponent = ({
  onChange,
  id,
  data,
  isEmpty = true,
  value,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const evaluacionesStore = Redux.useSelector((state) => state.evaluaciones);

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && evaluacionesStore.all.length === 0) {
        await allEvaluacionesAction(dispatch, null);
        setItems(evaluacionesStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      evaluacionesStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(evaluacionesStore.all);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${id}`}>{CONST.evaluaciones.label}</InputLabel>
      <Select
        id={CONST.ID}
        value={value}
        labelId={`label_${id}`}
        label={CONST.evaluaciones.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty && (
          <MenuItem key={`${id}-000-item`} value={null}>
            NINGUNO
          </MenuItem>
        )}
        {items.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-evaluaciones"
      opt={items}
      type={CONST.evaluaciones.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l={CONST.evaluaciones.label}
    />
  );

  return isAutoComplete ? autoComplete : select;
};

SelectFieldEvaluacionesComponent.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectFieldEvaluacionesComponent;
